<template>
    <button :class="{ disabled: isDisabled }" @click="onClick()">
        <i :class="icon" :title="$t(label)"></i>
        <span v-if="showButtonName" class="ml-1">{{ $t(label) }}</span>
        <b-spinner v-if="busy" small></b-spinner>
    </button>
</template>

<script>
const typeMapping = {
    search: {},
    add: {
        label: "btn.basic.add",
        icon: "fa fa-fw fa-lg fa-plus"
    },
    edit: {
        label: "btn.basic.edit",
        icon: "fa fa-pencil-alt"
    },
    delete: {
        label: "btn.basic.delete",
        icon: "fa fa-trash",
        precondition: function ($this) {
            return $this.$modal.confirmModal("msg.delete.alert");
        }
    },
    deleteWithoutAlert: {
        label: "btn.basic.delete",
        icon: "fa fa-trash"
    },
    view: {
        label: "btn.basic.view",
        icon: "fa fa-eye"
    },
    export: {
        label: "btn.basic.export",
        icon: "fa fa-file-export"
    },
    import: {
        label: "btn.basic.import",
        icon: "fa fa-file-import"
    },
    save: {
        label: "btn.basic.save",
        icon: "fa fa-fw fa-lg fa-save"
    },
    cancel: {
        label: "btn.basic.cancel",
        icon: "fa fa-times",
        class: ""
    },
    check: {
        label: "btn.basic.save",
        icon: "fa fa-check",
        class: ""
    },
    showEntity: {
        label: "btn.basic.view",
        icon: "fa fa-file-alt",
        class: ""
    },
    showAttachmentEntity: {
        label: "btn.basic.view",
        icon: "fa fa-paperclip",
        class: ""
    },
    log: {
        label: "btn.basic.view",
        icon: "fa fa-file-download text-primary"
    },
    downloadFile: {
        label: "btn.basic.downloadFile",
        icon: "fa fa-file-download"
    },
    uploadFile: {
        label: "btn.basic.uploadFile",
        icon: "fa fa-file-upload"
    },
    approve: {
        label: "btn.basic.approve",
        icon: "fa fa-fw fa-lg fa-check",
        precondition: function ($this) {
            return $this.$modal.confirmModal("msg.task.approve");
        }
    },
    issue: {
        label: "btn.basic.approve",
        icon: "fa fa-fw fa-lg fa-check",
        precondition: function ($this) {
            return $this.$modal.confirmModal("msg.task.issue");
        }
    },
    readOpc: {
        label: "btn.basic.approve",
        icon: "fa fa-fw fa-lg fa-check",
        precondition: function ($this) {
            return $this.$modal.confirmModal("确定要从OPC Server读取设备当前实测值吗？");
        }
    },
    reject: {
        label: "btn.basic.reject",
        icon: "fa fa-fw fa-lg fa-times",
        precondition: function ($this) {
            return $this.$modal.confirmModal("msg.task.reject");
        }
    },
    runPlans: {
        label: "em.btn.basic.runPlans",
        icon: "fa fa-fw fa-lg fa-check",
        precondition: function ($this) {
            return $this.$modal.confirmModal("msg.plan.runPlans");
        }
    },
    runDuePlans: {
        label: "em.btn.basic.runDuePlans",
        icon: "fa fa-fw fa-lg fa-check",
        precondition: function ($this) {
            return $this.$modal.confirmModal("msg.plan.runDuePlans");
        }
    },
    task: {
        label: "btn.basic.task",
        icon: "fa fa-fw fa-lg fa-check"
    },
    gotoGrandParent: {
        label: "btn.basic.gotoGrandParent",
        icon: "fa fa-fw fa-lg fa-reply"
    },
    gotoChild: {
        label: "btn.basic.gotoChild",
        icon: "fa fa-fw fa-lg fa-share"
    },
    gotoChildComponent: {
        label: "btn.basic.gotoChildComponent",
        icon: "fa fa-fw fa-lg fa-share"
    },
    gotoParentMaterial: {
        label: "btn.basic.gotoParentMaterial",
        icon: "fa fa-fw fa-lg fa-reply"
    },
    gotoChildMaterial: {
        label: "btn.basic.gotoChildMaterial",
        icon: "fa fa-fw fa-lg fa-share"
    },
    gotoTransport: {
        label: "btn.basic.gotoTransport",
        icon: "fa fa-fw fa-lg fa-share"
    },
    gotoSdr: {
        label: "btn.basic.gotoSdr",
        icon: "fa fa-fw fa-lg fa-share"
    },
    gotoExecute: {
        label: "btn.basic.gotoExecute",
        icon: "fa fa-fw fa-lg fa-play"
    },
    responseTask: {
        label: "btn.basic.responseTask",
        icon: "fa fa-fw fa-lg fa-paper-plane",
        precondition: function ($this) {
            return $this.$modal.confirmModal("msg.task.response");
        }
    },
    finishTask: {
        label: "btn.basic.finishTask",
        icon: "fa fa-fw fa-lg fa-recycle"
    },
    previewPdfFile: {
        label: "btn.basic.previewPdfFile",
        icon: "fa fa-fw fa-lg fa-file-pdf"
    },
    changePwd: {
        label: "btn.basic.changePwd",
        icon: "fa fa-key"
    },
    fillTemplate: {
        label: "btn.basic.fillTemplate",
        icon: "fa fa-pencil-square-o"
    },
    process: {
        label: "btn.basic.process",
        icon: "fa fa-code-fork"
    },
    qualified: {
        label: "btn.basic.qualified",
        icon: "fa fa-check",
    },
    copy: {
        label: "btn.basic.copy",
        icon: "fa fa-files-o",
    },
    viewAttachment: {
        label: "btn.basic.viewAttachment",
        icon: "fa fa-file",
    },
    user: {
        label: "btn.basic.user",
        icon: "fa-solid fa-user"
    },
    userSecret: {
        label: "btn.basic.user",
        icon: "fa-solid  fa-leaf"
    }
};

export default {
    name: "em-button",
    props: {
        type: String,
        disabled: Boolean,
        enabled: {
            type: Boolean,
            default: true
        },
        showName: Boolean,
        customLabel: String,
        customIcon: String,
        busy: Boolean,
        confirmText: String
    },
    data: function () {
        return {
            bType: this.type,
            showButtonName: this.showName
        };
    },
    computed: {
        isDisabled: function () {
            return this.busy ? this.busy : (this.disabled || !this.enabled);
        },
        icon: function () {
            return this.customIcon ? this.customIcon : typeMapping[this.bType].icon;
        },
        label: function () {
            return this.customLabel
                ? this.customLabel
                : typeMapping[this.bType].label;
        }
    },
    methods: {
        onClick() {
            let self = this;
            let precondition = typeMapping[this.bType].precondition;

            if (!this.isDisabled) {
                if (precondition) {
                    precondition(this).then(() => self.emitClick());
                } else if (this.confirmText) {
                    this.$modal.confirmModal(this.confirmText).then(() => self.emitClick())
                } else {
                    this.emitClick();
                }
            }
        },
        emitClick() {
            this.$emit("click");
            this.$interaction({
                identifyCode: 'em-button',
                actionName: 'btn-click',
                actionContent: this.$t(this.label) || this.type
            })
        },
    }
};
</script>
